document.addEventListener('click', function (event) {
  const button = event.target.closest('.custom-ajax-add');
  if (!button) return;

  event.preventDefault();

  const variantId = button.getAttribute('data-variant-id');
  button.classList.add('loading');

  let formData = {
    items: [{
      id: variantId,
      quantity: 1
    }]
  };

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(formData)
  })
    .then(res => res.json())
    .then(() => {
      if (window.qikify && window.qikify.cart) {
        window.qikify.cart.refresh();
      }
      if (window.qikify && window.qikify.cart) {
        window.qikify.cart.open();
      }
    })
    .catch(err => {
      console.error(err);
      alert('Error adding to cart');
    })
    .finally(() => {
      button.classList.remove('loading');
    });
});


const searchLink = document.querySelector('.site-header-search-link');
const liveSearch = document.querySelector('.live-search');
const liveSearchClose = document.querySelector('.live-search-close');

function openSearch(e) {
  e.preventDefault();
  liveSearch.style.opacity = '1';
  liveSearch.style.pointerEvents = 'auto';
}

function closeSearch() {
  liveSearch.style.opacity = '';
  liveSearch.style.pointerEvents = '';
}

searchLink.addEventListener('click', openSearch);
liveSearchClose.addEventListener('click', closeSearch);

document.addEventListener('click', function(e) {
  const isOutside = !liveSearch.contains(e.target) && !searchLink.contains(e.target);
  if (isOutside) {
    closeSearch();
  }
});


document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.pdp-tabs').forEach(function (tabs) {
    const items = tabs.querySelectorAll('.pdp-tab');

    function openTab(tab) {
      tab.classList.add('active');
      const content = tab.querySelector('.pdp-tab__content');
      content.style.maxHeight = content.scrollHeight + 'px';
    }

    function closeTab(tab) {
      tab.classList.remove('active');
      tab.querySelector('.pdp-tab__content').style.maxHeight = null;
    }

    items.forEach(function (tab) {
      tab.querySelector('.pdp-tab__trigger').addEventListener('click', function () {
        const isActive = tab.classList.contains('active');
        items.forEach(closeTab);
        if (!isActive) openTab(tab);
      });
    });
  });
});

window.addEventListener('load', function () {
  setTimeout(function () {
    window.dispatchEvent(new Event('resize'));
  }, 300);
});

(function () {
  if (!window.__customVariants) return;

  function formatMoney(cents) {
    return '€' + (cents / 100).toFixed(2).replace('.', ',');
  }

  function getSelectedVariant() {
    const checked = document.querySelectorAll('[data-variant-option-value]:checked');
    if (!checked.length) return null;
    const selectedOptions = Array.from(checked).map(i => i.value);
    return window.__customVariants.find(v =>
      selectedOptions.every((opt, idx) => v.options[idx] === opt)
    ) || null;
  }

  let _lastVariantId = null;
  let observer = new MutationObserver(function () {
    const variant = getSelectedVariant();
    if (!variant) return;
    const pricing = document.querySelector('[data-product-pricing]');
    if (!pricing) return;
    const currentShown = pricing.querySelector('[data-price-container]');
    const expectedPrice = formatMoney(variant.price);
    if (currentShown && currentShown.textContent.trim() !== expectedPrice) {
      _lastVariantId = null;
      updatePrice(variant);
    }
  });

  function observePricing() {
    const pricing = document.querySelector('[data-product-pricing]');
    if (pricing) {
      observer.observe(pricing, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class']
      });
    }
  }

  function updatePrice(variant) {
    if (!variant) return;
    if (variant.id === _lastVariantId) return;
    _lastVariantId = variant.id;

    const pricing = document.querySelector('[data-product-pricing]');
    if (!pricing) return;

    const price = variant.price;
    const comparePrice = variant.compare_at_price;
    const hasCompare = comparePrice && comparePrice > price;

    observer.disconnect();

    // ── Current price ────────────────────────────────────────
    const currentRangeHidden  = pricing.querySelector('[data-current-price-range-hidden]');
    const currentSingleHidden = pricing.querySelector('[data-current-price-hidden]');
    const currentShown        = pricing.querySelector('[data-price-container]');

    if (currentRangeHidden)  currentRangeHidden.className  = 'price__current--hidden';
    if (currentSingleHidden) currentSingleHidden.className = 'price__current--hidden';
    if (currentShown)        currentShown.textContent      = formatMoney(price);

    pricing.querySelectorAll('[data-price]').forEach(el => {
      el.textContent = formatMoney(price);
    });

    // ── Compare price ────────────────────────────────────────
    const compareContainer    = pricing.querySelector('[data-price-compare-container]');
    const compareRangeHidden  = pricing.querySelector('[data-compare-price-range-hidden]');
    const compareSingleHidden = pricing.querySelector('[data-compare-price-hidden]');

    if (hasCompare) {
      if (compareRangeHidden)  compareRangeHidden.className  = 'price__compare-at--hidden';
      if (compareSingleHidden) compareSingleHidden.className = 'price__compare-at--hidden';

      if (compareContainer) {
        compareContainer.className = 'price__compare-at visible';
        compareContainer.innerHTML = `
          <span class="visually-hidden">Oorspronkelijke prijs</span>
          <span class="money price__compare-at--single" data-price-compare>${formatMoney(comparePrice)}</span>
        `;
      }
    } else {
      if (compareContainer)    compareContainer.className    = 'price__compare-at--hidden';
      if (compareRangeHidden)  compareRangeHidden.className  = 'price__compare-at--hidden';
      if (compareSingleHidden) compareSingleHidden.className = 'price__compare-at--hidden';
    }

    // ── Badge ────────────────────────────────────────────────
    const badgeWrapper = pricing.querySelector('[data-badge-sales]');
    const badgeRange   = pricing.querySelector('[data-badge-sales-range]');
    const badgeSingle  = pricing.querySelector('[data-badge-sales-single]');

    if (badgeWrapper) {
      if (hasCompare) {
        const savingsPct = Math.round((1 - price / comparePrice) * 100);
        if (badgeSingle) {
          badgeSingle.innerHTML = 'Bespaar <strong>' + savingsPct + '%</strong>';
          badgeSingle.style.display = '';
        }
        if (badgeRange) badgeRange.style.display = 'none';
        badgeWrapper.style.removeProperty('display');
      } else {
        badgeWrapper.style.display = 'none';
      }
    }

    observePricing();
  }

  function init() {
    document.addEventListener('change', function (e) {
      if (e.target.matches('[data-variant-option-value]')) {
        _lastVariantId = null;
        const variant = getSelectedVariant();
        if (variant) updatePrice(variant);
      }
    });

    observePricing();

    let attempts = 0;
    const interval = setInterval(function () {
      attempts++;
      const checked = document.querySelectorAll('[data-variant-option-value]:checked');
      if (checked.length > 0) {
        clearInterval(interval);
        const variant = getSelectedVariant();
        if (variant) updatePrice(variant);
      }
      if (attempts > 40) clearInterval(interval);
    }, 100);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();


(function() {
  function initBadge() {
    var badge = document.querySelector('.media-badge[data-first-media-id]');
    if (!badge) return;

    var firstMediaId = badge.getAttribute('data-first-media-id');
    var gallery = badge.closest('[data-product-gallery]');
    if (!gallery) return;

    function checkActiveSlide() {
      var activeFigure = gallery.querySelector('[data-gallery-figure][data-gallery-selected="true"]');
      if (!activeFigure) return;

      var activeMediaId = activeFigure.getAttribute('data-media');
      badge.style.display = (activeMediaId === firstMediaId) ? '' : 'none';
    }

    // Run on load
    checkActiveSlide();

    // Watch for attribute changes on all figures
    var figures = gallery.querySelectorAll('[data-gallery-figure]');
    figures.forEach(function(figure) {
      var observer = new MutationObserver(checkActiveSlide);
      observer.observe(figure, {
        attributes: true,
        attributeFilter: ['data-gallery-selected']
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBadge);
  } else {
    initBadge();
  }
})();